/* unplugin-vue-components disabled */import script from "./DishesOrderItemsCard.vue?vue&type=script&setup=true&lang=js"
export * from "./DishesOrderItemsCard.vue?vue&type=script&setup=true&lang=js"

import "./DishesOrderItemsCard.vue?vue&type=style&index=0&id=76c2a696&lang=scss"

const __exports__ = script;

export default __exports__